import { apiGet, apiPost, apiPut, apiDelete } from '../lib/api'

export const LESSONS_LOAD_START = 'LESSONS_LOAD_START'
export const LESSONS_LOAD_SUCCESS = 'LESSONS_LOAD_SUCCESS'
export const LESSONS_LOAD_ERROR = 'LESSONS_LOAD_ERROR'

export const RELATED_LESSONS_LOAD_START = 'RELATED_LESSONS_LOAD_START'
export const RELATED_LESSONS_LOAD_SUCCESS = 'RELATED_LESSONS_LOAD_SUCCESS'
export const RELATED_LESSONS_LOAD_ERROR = 'RELATED_LESSONS_LOAD_ERROR'

export const LESSON_LOAD_START = 'LESSON_LOAD_START'
export const LESSON_LOAD_SUCCESS = 'LESSON_LOAD_SUCCESS'
export const LESSON_LOAD_ERROR = 'LESSON_LOAD_ERROR'

export const LESSON_ADD_START = 'LESSON_ADD_START'
export const LESSON_ADD_SUCCESS = 'LESSON_ADD_SUCCESS'
export const LESSON_ADD_ERROR = 'LESSON_ADD_ERROR'

export const SET_CURRENT_LESSON = 'SET_CURRENT_LESSON'
export const LESSON_CLEAR_DETAIL = 'LESSON_CLEAR_DETAIL'

export const LESSON_EDIT_START = 'LESSON_EDIT_START'
export const LESSON_EDIT_SUCCESS = 'LESSON_EDIT_SUCCESS'
export const LESSON_EDIT_ERROR = 'LESSON_EDIT_ERROR'

export const WORD_TRANSLATE_START = 'WORD_TRANSLATE_START'
export const WORD_TRANSLATE_SUCCESS = 'WORD_TRANSLATE_SUCCESS'
export const WORD_TRANSLATE_ERROR = 'WORD_TRANSLATE_ERROR'

export const WORD_AUTOCOMPLETE_START = 'WORD_AUTOCOMPLETE_START'
export const WORD_AUTOCOMPLETE_SUCCESS = 'WORD_AUTOCOMPLETE_SUCCESS'
export const WORD_AUTOCOMPLETE_ERROR = 'WORD_AUTOCOMPLETE_ERROR'

export const LESSON_DELETE_START = 'LESSON_DELETE_START'
export const LESSON_DELETE_SUCCESS = 'LESSON_DELETE_SUCCESS'
export const LESSON_DELETE_ERROR = 'LESSON_DELETE_ERROR'

export const GET_PUBLIC_LESSONS_START = 'GET_PUBLIC_LESSONS_START'
export const GET_PUBLIC_LESSONS_SUCCESS = 'GET_PUBLIC_LESSONS_SUCCESS'
export const GET_PUBLIC_LESSONS_ERROR = 'GET_PUBLIC_LESSONS_ERROR'

export const LESSON_ADD_FAVORITE_START = 'LESSON_ADD_FAVORITE_START'
export const LESSON_ADD_FAVORITE_SUCCESS = 'LESSON_ADD_FAVORITE_SUCCESS'
export const LESSON_ADD_FAVORITE_ERROR = 'LESSON_ADD_FAVORITE_ERROR'

export const LESSON_REMOVE_FAVORITE_START = 'LESSON_REMOVE_FAVORITE_START'
export const LESSON_REMOVE_FAVORITE_SUCCESS = 'LESSON_REMOVE_FAVORITE_SUCCESS'
export const LESSON_REMOVE_FAVORITE_ERROR = 'LESSON_REMOVE_FAVORITE_ERROR'

export const LESSON_STUDIED = 'LESSON_STUDIED'
export const CLEAR_SUGGESTION = 'CLEAR_SUGGESTION'
export const CLEAR_AUTOCOMPLETE = 'CLEAR_AUTOCOMPLETE'

export const SHOW_HOMEWORK_FORM = 'SHOW_HOMEWORK_FORM'
export const HIDE_HOMEWORK_FORM = 'HIDE_HOMEWORK_FORM'

export const RELATED_LESSONS_CLEAR = 'RELATED_LESSONS_CLEAR'

export const loadLessons = () => ({ getState, fetch }) => ({
  type: 'LESSONS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'lesson',
    getState,
  }),
})

export const loadLessonDetail = (id) => ({ getState, fetch }) => ({
  type: 'LESSON_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `lesson/${id}`,
    getState,
  }),
})

export const loadRelatedLessons = (id) => ({ getState, fetch }) => ({
  type: 'RELATED_LESSONS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `lesson/${id}/related`,
    getState,
  }),
})

export const createLesson = (body) => ({ getState, fetch }) => ({
  type: 'LESSON_ADD',
  payload: apiPost({
    fetch,
    endpoint: 'lesson',
    getState,
    body,
  }),
})

export const editLesson = (body) => ({ getState, fetch }) => ({
  type: 'LESSON_EDIT',
  payload: apiPut({
    fetch,
    endpoint: `lesson/${body.id}`,
    getState,
    body,
  }),
})

export const deleteLesson = (id) => ({ getState, fetch }) => ({
  type: 'LESSON_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `lesson/${id}`,
    getState,
  }),
})

export const setCurrentLesson = (lesson) => ({
  type: 'SET_CURRENT_LESSON',
  payload: { data: lesson },
})

export const getPublicLessons = (query) => ({ getState, fetch }) => ({
  type: 'GET_PUBLIC_LESSONS',
  payload: apiGet({
    fetch,
    endpoint: `/lesson/search/public?${query}`,
    getState,
  }),
})

export const getUserLessons = (query) => ({ getState, fetch }) => ({
  type: 'GET_PUBLIC_LESSONS',
  payload: apiGet({
    fetch,
    endpoint: `/lesson/user/${query}`,
    getState,
  }),
})

export const addFavoriteLesson = (id) => ({ getState, fetch }) => ({
  type: 'LESSON_ADD_FAVORITE',
  payload: apiPost({
    fetch,
    endpoint: `/lesson/favorite/${id}`,
    getState,
  }),
})

export const vocabularyStudied = (lessonId, body) => ({ getState, fetch }) => ({
  type: 'LESSON_STUDIED',
  payload: apiPost({
    fetch,
    endpoint: `/lesson/${lessonId}/studied`,
    getState,
    body,
  }),
})

export const vocabularyAnswerCreate = (body) => ({ getState, fetch }) => ({
  type: 'LESSON_VOCABULARY_ANSWER_CREATED',
  payload: apiPost({
    fetch,
    endpoint: `/lesson/${body.lesson}/word-answer`,
    getState,
    body,
  }),
})

export const wordTranslate = (word, langFrom, langTo) => ({ getState, fetch }) => ({
  type: 'WORD_TRANSLATE',
  payload: apiPost({
    fetch,
    endpoint: `/lesson/translate/${word}/${langFrom}/${langTo}`,
    getState,
  }),
})

export const wordAutocomplete = (word, lang) => ({ getState, fetch }) => ({
  type: 'WORD_AUTOCOMPLETE',
  payload: apiPost({
    fetch,
    endpoint: `/lesson/suggest/${word}/${lang}`,
    getState,
  }),
})

export const removeFavoriteLesson = (id) => ({ getState, fetch }) => ({
  type: 'LESSON_REMOVE_FAVORITE',
  payload: apiDelete({
    fetch,
    endpoint: `/lesson/favorite/${id}`,
    getState,
  }),
})

export const clearAutocomplete = () => ({
  type: CLEAR_AUTOCOMPLETE,
})

export const clearSuggestion = () => ({
  type: CLEAR_SUGGESTION,
})

export const clearLessonDetail = () => ({
  type: LESSON_CLEAR_DETAIL,
})

export const clearRelatedLessons = () => ({
  type: RELATED_LESSONS_CLEAR,
})

export const showHomeworkForm = () => ({
  type: SHOW_HOMEWORK_FORM,
})

export const hideHomeworkForm = () => ({
  type: HIDE_HOMEWORK_FORM,
})



// WEBPACK FOOTER //
// ./src/common/lessons/actions.js